<template>
  <section>
    <!-- <a href target="_blank" rel="noopener noreferrer">
      <img src="/static/images/topguanggao.png" alt srcset class="topguanggao" />
    </a>-->
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword" :cartnum="cartnum"></Header>

    <div class="container">
      <div class="cartit">
        <span class="tit">全部商品（{{carlist.productnum}}）</span>
      </div>
      <div class="cartcontent">
        <table class="layui-table" lay-skin="line">
          <tr class="theader" style="background-color: #f8f8f8;">
            <td width="150">
              <input
                type="checkbox"
                :checked="carlist.checkedall"
                @click="selectedAll(carlist.checkedall)"
                lay-skin="primary"
              />
              {{carlist.checkedall?'全不选':'全选'}}
            </td>
            <td>商品信息</td>
            <td class="cart-price">单价</td>
            <td class="cart-numbers">数量</td>
            <td class="cart-total">金额</td>
            <td class="cart-ctrl">操作</td>
          </tr>
        </table>
        <table class="layui-table" lay-skin="line" v-for="(item,index) in carlist.shoplist" :key='index'>
          <tr class="theader" style="background-color: #f8f8f8;">
            <td colspan="6">
              <span @click="selectedStore(item)">
                <input type="checkbox" lay-skin="primary" :checked="item.checkedall" title />
              </span>
              <a href>
                {{item.name}}
                <i class="iconfont icon-right"></i>
              </a>
            </td>
          </tr>
          <tbody>
            <tr v-for="(item_i,index_i) in item.items " :key='index_i'>
              <td class="cart-select">
                <span v-on:click="selectedOneGoods(item_i)">
                  <input type="checkbox" name="xuanze" :checked="item_i.checked" lay-skin="primary" />
                </span>
              </td>
              <td>
                <div class="clearfix cpinfo">
                  <div class="img">
                    <img :src="item_i.indexpic" />
                  </div>
                  <div class="cont">
                    <div class="name">{{item_i.title}}</div>
                    <div class="info">{{item_i.specname}}</div>
                  </div>
                </div>
              </td>
              <td class="cart-price">
                <strong>￥{{item_i.price}}</strong>
              </td>
              <td class="cart-numbers">
                <div class="numberbox">
                  <button
                    type="button"
                    class="btn jian"
                    :disabled="item_i.num<=1"
                    @click="xiugaiNum(item_i,'reduce',item_i.num)"
                  >
                    <span class="iconfont icon-jian"></span>
                  </button>
                  <input type="text" @change="changeCarNum(item_i)" :min="1" v-model="item_i.num"/>
                  <button type="button" @click="xiugaiNum(item_i,'add',item_i.num)" class="btn jia">
                    <span class="iconfont icon-jia"></span>
                  </button>
                </div>
              </td>
              <td class="cart-total">
                <strong class="color-red">￥{{(item_i.price*item_i.num).toFixed(2)}}</strong>
              </td>
              <td class="cart-ctrl">
                <a href="javascript:;" @click="detele(item_i)">删除</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="cartfooter">
        <div class="fl flex height100%">
          <input
            type="checkbox"
            lay-skin="primary"
            :checked="carlist.checkedall"
            @click="selectedAll(carlist.checkedall)"
          />
          {{carlist.checkedall?'全不选':'全选'}}&nbsp;&nbsp;&nbsp;&nbsp;
          <a
            href="javascript:;"
            @click="detele"
          >删除</a>&nbsp;&nbsp;&nbsp;&nbsp;
          <!-- <a href="javascript:;">移入收藏夹</a> -->
        </div>

        <div class="fr">
          <a href="javascript:;" @click="submit" class="layui-btn layui-btn-lg">去结算</a>
        </div>
        <div class="fr flex height100" style="padding-right: 15px;">
          已选择
          <strong>{{carlist.productnum}}</strong> 件商品，合计(不含运费)：
          <strong class="color-red">￥{{carlist.total}}</strong>
        </div>
      </div>
      <div style="font-size: 18px; font-weight: bold; margin-top: 50px;">猜你喜欢</div>
      <div class="product-list">
        <ul class="clearlist clearfix">
          <li class="item" v-for="(item,index) in cainixihuan.data" :key='index'>
            <a :href="'product/'+item.id+'.html'">
              <div class="img">
                <img :src="item.indexpic" />
              </div>
              <div class="tit ellipsis-2">{{item.title}}</div>
              <div class="price">
                <span class="xianjia">￥{{item.price}}</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <Footer :indexData="indexData"></Footer>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";

// let total = 10;
export default {
  components: {
    Header,
    Footer
  },
  name: "index",
  data() {
    return {
      cartnum:0,
      categoryid: getParameterByName("categoryid"),
      carlist: {}, //购物车数据
      guid: sessionStorage.guid,
      userInfo: {},
      indexData: {},
      keyword: decodeURI(getQueryVariable("keyword")),
      autotroph: sessionStorage.autotroph,
      cainixihuan: {} ,//猜你喜欢
	//isstaff:JSON.parse(sessionStorage.jinruser).isstaff
    };
  },
  methods: {
    // 获取购物车列表
    async getCarlist() {
    
      let res = await this.$fetch("Cart/cartinfo", {});
       console.log("重新请求数据",res);
      if (res) {
        this.carlist = res;
        this.cartnum=res.allnum
        // alert(this.cartnum)
      }
    },
    // 删除
    async detele(item) {
      console.log(item);
      if (item.productid) {
        let { num, productid, specification } = item;
        let res = await this.$fetch("Cart/del", {
          body: {
            productid,
            specification
          }
        });
      } else {
         let res = await this.$fetch("Cart/batchdel");
      }

      // if (res) {
        this.$message.success("删除成功");
        this.getCarlist();
      // }
    },
    async changeCarNum(item){
      console.log(item)
       let res = await this.$fetch("Cart/edit", {
        body: {
          productid: item.productid,
          specification: item.specification,
          num:item.num||1
        }
      });
      this.getCarlist();
    },
    // 选中或者不选中单个商品
    async selectedOneGoods(item) {
      console.log(item);
      let res = await this.$fetch("Cart/check", {
        body: {
          productid: item.id,
          checked: item.checked ? 0 : 1
        }
      });

      this.getCarlist();
    },
    //选中或者不选中当前店铺
    async selectedStore(item) {
      console.log(item);
      let res = await this.$fetch("Cart/check", {
        body: {
          shopid: item.shopid,
          checked: item.checkedall ? 0 : 1,
          isall: 1
        }
      });
      console.log("修改成功");
      this.getCarlist();
    },
    // 修改单个商品数量
    async xiugaiNum(item, type, num) {
      if (type == "add") {
        num = num + 1;
      } else {
        num = num - 1;
      }
      let res = await this.$fetch("Cart/edit", {
        body: {
          productid: item.productid,
          specification: item.specification,
          num
        }
      });
      this.getCarlist();
    },
    // 全选和全部不选
    async selectedAll(checked) {
      console.log("checked", checked);
      let res = await this.$fetch("Cart/check", {
        body: {
          checked: checked ? 0 : 1,
          isall: 1
        }
      });
      console.log("修改成功");
      this.getCarlist();
    },
    // 去结算页面
    async submit() {
      let res = await this.$fetch("Cart/cartchecked", {});
      if (res && res.shoplist.length == 0) {
        layer.alert("请勾选商品", { icon: 2 });
        return;
      }
	  
      this.$router.push("/jiesuan");
    }
  },
  async mounted() {
    if (!sessionStorage.guid) {
      this.$router.push("/login");
      return;
    }
    this.getCarlist();
    this.indexData = await this.$fetch("Index/indexdata");
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }

    // 猜你喜欢
    this.cainixihuan = await this.$fetch("Shop/productlist", {
      body: {
        page: 1,
        pagesize: 10,
        guess: 1
      }
    });
	
    // this.getProduct_list();
    // this.keyword = decodeURI(getQueryVariable("keyword"));
  }
};
</script>


<style lang='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/pages/cart.vue